import React, { Component } from 'react';
import UvmMenu from '../menu';
import Logo from './logo';
import TopMenu from "../topMenu/topMenu";

class Header extends Component {
  render() {
    const { token, group, menu } = this.props;
    return (
      <header style={{ 
        backgroundColor: this.props.bgc, 
        backgroundImage:this.props.bgi==='none'?this.props.big:"url("+this.props.bgi+")", 
        padding: this.props.padding, 
        height: this.props.height, 
        minHeight: this.props.minHeight,
        maxHeight: this.props.maxHeight,
        maxWidth: this.props.maxWidth, 
        width: this.props.width, 
        ...this.props.styles,
        display:this.props.display,
      }}>
        <div className="topBar"
          style={{
            height:"60px",
            backgroundColor:"#a7d233",
            top:"0"
          }}>
          <TopMenu />
        </div>
        <Logo token={token} />
        {typeof group !== 'undefined'
          ?<UvmMenu groupTitle={group.name} menu={menu} />
          :null}
      </header>
    );
  }
}

Header.defaultProps = {
  height: "auto",
  minHeight: "100px",
  maxHeight: "100px",
  padding: "0",
  bgc:"#fff",
  bgi: "none",
  styles: {
      color: "#444",
      fontSize: "19px",
      fontFamily: "Oswald, sans-serif",
      lineHeight: " 19px",
      border: "0px dashed #cc00cc",
      margin:"0",
  },
  children: "woot",
  display:"flex"
}

export default Header;